import './compositions/global.js';
import './compositions/menu.js';
import './compositions/animations.js';
import './compositions/sliders.js';